import { AlertTriangle, RotateCcw, ShieldAlert } from 'lucide-react';
import { cn } from '../../lib/utils';
import { useSfeVersion } from '../../api/queries/sfe-version';

// ─────────────────────────────────────────────────────────────
// Banner of the SFE version this install runs (AppLayout, beside the
// licence banner), for every signed-in user (#622 D): the DGI's notice of
// a provisional suspension or a withdrawal of its attestation, as the API
// words it, and the publisher's request to return to an older homologated
// version (#631), shown beside it, never applied from here. Nothing while
// attested or re-established with no such request; errors render nothing.
// ─────────────────────────────────────────────────────────────

export function SfeVersionBanner() {
  const { data } = useSfeVersion();
  if (!data) return null;
  const pin = data.pin ?? null;
  if (data.notice === null && pin === null) return null;

  const withdrawn = data.state === 'WITHDRAWN';
  return (
    <>
      {data.notice !== null && (
        <div
          role={withdrawn ? 'alert' : 'status'}
          className={cn(
            'mb-4 flex items-start gap-2 rounded-xl border px-4 py-3 text-sm',
            withdrawn ? 'border-red-200 bg-red-50 text-red-800' : 'border-amber-200 bg-amber-50 text-amber-800'
          )}
        >
          {withdrawn ? (
            <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" />
          ) : (
            <ShieldAlert className="mt-0.5 h-4 w-4 flex-shrink-0" />
          )}
          <p className="min-w-0">
            <span className="font-semibold">
              {withdrawn ? 'Attestation de conformité retirée' : 'Attestation de conformité suspendue'}
            </span>{' '}
            — {data.notice}
          </p>
        </div>
      )}
      {pin !== null && (
        <div
          role="status"
          data-testid="sfe-version-pin"
          className="mb-4 flex items-start gap-2 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-800"
        >
          <RotateCcw className="mt-0.5 h-4 w-4 flex-shrink-0" aria-hidden="true" />
          <p className="min-w-0">{pin.notice}</p>
        </div>
      )}
    </>
  );
}

export default SfeVersionBanner;
